import type { CSSProperties } from "react";

/**
 * The brand's purple, for bookings drawn in one colour — a therapist's own
 * agenda — and the first colour the centre agenda gives a therapist.
 */
export const BRAND_BOOKING_COLOR = "#6a4fd8";

/**
 * A booking's card: a wash of its colour with a solid edge, the text in the
 * theme's own ink so it reads on either background. A booking that has
 * already happened keeps the hue at a fraction of its strength.
 *
 * The wash is laid over the card's own opaque background (`bg-white` /
 * `dark:bg-gray-900`), so a card overlapping another hides what is under it
 * instead of letting both texts show through.
 */
export function bookingCardStyle(color: string, past: boolean): CSSProperties {
    const wash = `${color}${past ? "14" : "2e"}`;
    return {
        backgroundImage: `linear-gradient(${wash}, ${wash})`,
        borderLeftColor: past ? `${color}80` : color,
    };
}
